import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Trips
export const fetchTrips = (params = {}) => apiClient.get("/trips", { params }).then((r) => r.data);
export const fetchTrip = (id) => apiClient.get(`/trips/${id}`).then((r) => r.data);
export const createTrip = (data) => apiClient.post("/trips", data).then((r) => r.data);
export const updateTrip = (id, data) => apiClient.put(`/trips/${id}`, data).then((r) => r.data);
export const updateStatus = (id, payload) => apiClient.patch(`/trips/${id}/status`, payload).then((r) => r.data);

// Messages
export const addMessage = (id, payload) => apiClient.post(`/trips/${id}/messages`, payload).then((r) => r.data);
export const fetchTemplates = () => apiClient.get("/message-templates").then((r) => r.data);

// Dashboard
export const fetchStats = () => apiClient.get("/dashboard/stats").then((r) => r.data);
export const fetchUpcoming = (limit = 8) => apiClient.get("/dashboard/upcoming-arrivals", { params: { limit } }).then((r) => r.data);

// Admin auth
export const adminLogin = (username, password) => apiClient.post("/admin/login", { username, password }).then((r) => r.data);

// Driver roster — used in the admin assign-driver dropdown
export const DRIVERS = [
  "Luis",
  "Javier",
  "Obed",
  "Rogelio",
  "Matias",
  "Alexis",
  "Miguel",
  "Norberto",
  "Alan",
  "Richard",
  "Isai",
];

export const STATUSES = [
  "Draft",
  "Submitted",
  "Pending Review",
  "Need More Info",
  "Confirmed",
  "Updated",
  "Arrived",
  "Departed",
  "Closed",
];

export const DESTINATIONS = ["Monterrey", "Apodaca"];

// Driver
export const assignDriver = (id, payload) => apiClient.patch(`/trips/${id}/driver`, payload).then((r) => r.data);
export const unassignDriver = (id) => apiClient.delete(`/trips/${id}/driver`).then((r) => r.data);
